module.exports = __webpack_public_path__ + "img/brief_header.0597989f.png";